import MuiCard, { CardProps as MuiCardProps } from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';

// export const Card: React.FC<MuiCardProps> = ({ ...props }) => {

export function Card<C extends React.ElementType = 'div'>(
  props: MuiCardProps<C, { component?: C }>
) {
  return (
    <MuiCard
      elevation={props.variant === 'elevation' ? 1 : undefined}
      {...props}
    ></MuiCard>
  );
}

export { CardHeader, CardContent, CardActions, CardMedia, CardActionArea };
